import { render, staticRenderFns } from "./switcherDisabledAdUnitIcon.vue?vue&type=template&id=1b3d14fa&"
import script from "./switcherDisabledAdUnitIcon.vue?vue&type=script&lang=js&"
export * from "./switcherDisabledAdUnitIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports